<!-- section template -->
<template>
  <div :class="[$style.itemInfoBoxJtails, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <BaseStoreTagList :store-list="[reservationItem.store]" class="d-none d-md-flex" />
    <div class="itemInfoBoxJtails__title">
      {{ reservationItem.title }}
    </div>
    <div class="itemInfoBoxJtails__info">
      <div v-if="$globalCategoryVisible">
        <i v-if="$globalIsDingBeauty" class="fontello fontello-db-lipstick fa-fw mr-2 text-primary"></i>
        <i v-else class="fontello fontello-db-lipstick fa-fw mr-2 text-gray-3"></i>
        <span>
          <span v-if="!$globalIsDingBeauty">{{ $t('site.USER') }}：</span>
          <span>{{ reservationItem.categoryTitle }} | {{ reservationItem.sizeTitle }}</span>
        </span>
      </div>
      <div>
        <i v-if="$globalIsDingBeauty" class="fontello fontello-calendar fa-fw mr-2 text-primary"></i>
        <i v-else class="fontello fontello-calendar fa-fw mr-2 text-gray-3"></i>
        <span>
          <span>日期：</span>
          <span v-if="submitData.date && !isIncludDisabledDayList">
            {{ formatDate(submitData.date, 'yyyy/MM/dd (EEE)') }}
          </span>
          <span v-else class="text-danger">{{ '請選擇預約日期' }}</span>
        </span>
      </div>
      <div>
        <i v-if="$globalIsDingBeauty" class="fontello fontello-time fa-fw mr-2 text-primary"></i>
        <i v-else class="fontello fontello-time fa-fw mr-2 text-gray-3"></i>
        <span>
          <span>預約時段：</span>
          <span v-if="submitData.time">{{ submitData.time }}</span>
          <span v-else class="text-danger">{{ '請選擇預約時段' }}</span>
        </span>
      </div>
      <div v-if="currentMerchant.cosmeticSetting.canSpecifyScheduleItem">
        <span class="inline-block mr-2">
          <svg alt="comb" xmlns="http://www.w3.org/2000/svg" width="15.338" height="15.338" viewBox="0 0 15.338 15.338">
            <g id="_9070668_comb_icon" data-name="9070668_comb_icon" transform="translate(0.707 0.707)" opacity="0.803">
              <path
                id="Path_356674"
                data-name="Path 356674"
                d="M4.2,13.79l4.542,4.542,9.589-9.589L13.79,4.2"
                transform="translate(-4.201 -4.201)"
                fill="none"
                :stroke="$globalIsDingBeauty ? '#E3C192' : '#bbc3c9'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_356675"
                data-name="Path 356675"
                d="M9.151,26.121l2.523,2.523"
                transform="translate(-7.384 -18.299)"
                fill="none"
                :stroke="$globalIsDingBeauty ? '#E3C192' : '#bbc3c9'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_356676"
                data-name="Path 356676"
                d="M14.808,20.464l2.523,2.523"
                transform="translate(-11.023 -14.661)"
                fill="none"
                :stroke="$globalIsDingBeauty ? '#E3C192' : '#bbc3c9'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_356677"
                data-name="Path 356677"
                d="M20.464,14.808l2.523,2.523"
                transform="translate(-14.661 -11.023)"
                fill="none"
                :stroke="$globalIsDingBeauty ? '#E3C192' : '#bbc3c9'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_356678"
                data-name="Path 356678"
                d="M26.121,9.151l2.523,2.523"
                transform="translate(-18.299 -7.384)"
                fill="none"
                :stroke="$globalIsDingBeauty ? '#E3C192' : '#bbc3c9'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
              <path
                id="Path_356679"
                data-name="Path 356679"
                d="M12.686,22.275l9.589-9.589"
                transform="translate(-9.658 -9.658)"
                fill="none"
                :stroke="$globalIsDingBeauty ? '#E3C192' : '#bbc3c9'"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              />
            </g>
          </svg>
        </span>
        <span>
          <span>指定美容師：</span>
          <!-- <span v-if="isIncludDisabledDayList || !submitData.time"> {{'尚未選擇時段'}}</span> -->
          <template v-if="submitData.scheduleItemId && submitData.scheduleItemId[0]">
            <span>{{ reservationItem.store.scheduleItems.find((item) => item.id === submitData.scheduleItemId[0]).name }}</span>
          </template>
          <span v-else>{{ '不指定' }}</span>
        </span>
      </div>
    </div>
    <BaseList :data-list="billList" type="bill" class="mb-4 d-none d-md-block" />
    <div class="itemInfoBoxJtails__mobile-info">
      <div v-if="activeMemberApplicablePrepaidItem().prepaid" class="itemInfoBoxJtails__prepaid-info">
        使用{{ `${currentMerchant.prepaidSetting.title || '包套方案'}` }}：{{
          activeMemberApplicablePrepaidItem().prepaid ? activeMemberApplicablePrepaidItem().prepaid.title : `${currentMerchant.prepaidSetting.title || '包套方案'}`
        }}
      </div>
      <div class="itemInfoBoxJtails__mobile-info__left">
        <span class="itemInfoBoxJtails__mobile-info__title">
          <template v-if="reservationItem.levelDiscount > 0">
            <template v-if="$route.query.prepaidId"> 免費(NT$ 0) </template>
            <template v-else>
              {{ formatPrice(memberLevelPriceDiscount(reservationItem.price, reservationItem)) }}
              <span class="font-number text-decoration-line-through fs-2sm text-gray-2">NT$ {{ reservationItem.price }}</span>
            </template>
          </template>
          <template v-else>
            {{ $route.query.prepaidId ? `免費(NT$ 0)` : formatPrice(reservationItem.price) }}
          </template>
        </span>
        <!-- <span class="itemInfoBoxJtails__mobile-info__title">{{
            $route.query.prepaidId
              ? `免費(NT$ 0)`
              : formatPrice(reservationItem.price)
          }}</span> -->
        <span class="fs-2sm">
          <span v-if="submitData.date && submitData.time && !isIncludDisabledDayList" class="text-gray-2"> {{ formatDate(submitData.date, 'yyyy/MM/dd (EEE)') }} {{ submitData.time }} </span>
          <span v-else-if="!submitData.date || isIncludDisabledDayList" class="text-danger">
            {{ '請選擇預約日期' }}
          </span>
          <span v-else class="text-danger">
            {{ '請選擇預約時段' }}
          </span>
        </span>
      </div>
      <div class="itemInfoBoxJtails__mobile-info__inner">
        <template v-if="!isSiteEnabled">
          <BaseButton class="isStyleSecondary isRadius isFull" disabled> 尚未開放預約 </BaseButton>
        </template>
        <template v-else-if="!submitData.date || isIncludDisabledDayList">
          <BaseButton
            class="isStyleSecondary isFull"
            :class="{
              isRadius: $globalIsJtails,
            }"
            @click="scrollToId('date')"
          >
            選擇日期
          </BaseButton>
        </template>
        <template v-else-if="!submitData.time">
          <BaseButton
            class="isStyleSecondary isFull"
            :class="{
              isRadius: $globalIsJtails,
              isOutline: $globalIsDingBeauty,
            }"
            @click="chooseTime"
          >
            選擇時段
          </BaseButton>
        </template>
        <template v-else-if="!isScheduleItemIdCanAssign">
          <BaseButton
            class="isStyleDark isFull"
            :class="{
              isRadius: $globalIsJtails,
            }"
            @click="scrollToId('beautician')"
          >
            此時段設計師無法預約
          </BaseButton>
        </template>
        <template v-else>
          <BaseButton
            :loading="$isLoading('storeCart')"
            class="isStylePrimary isFull"
            :class="{
              isRadius: $globalIsJtails,
            }"
            :disabled="$isLoading('fetchReservationItem')"
            @click="onSubmit"
          >
            下一步
          </BaseButton>
        </template>
      </div>
    </div>

    <BasePre>{{ submitData.scheduleItems }}</BasePre>
  </div>
</template>
<script>
import formatDate from '@utils/format-date'
import { memberApplicablePrepaidOptions } from '@utils/ipetbooking-options'
import { authComputed, merchantComputed } from '@store/helpers'
import getISODay from 'date-fns/getISODay'
import { getDefaultReservationDisabledDayList } from '@utils/ipetbooking-get-default'
import parseISO from 'date-fns/parseISO'
import formatPrice from '@utils/format-price'
import formatCurrency from '@utils/format-currency'
import { conditionList } from '@utils/is-condition'
import { memberLevelPriceDiscount } from '@utils/ipetbooking-level'

export default {
  props: {
    submitData: {
      type: Object,
      default: () => {
        return {
          date: new Date(),
          time: '',
        }
      },
    },
    reservationItem: {
      type: Object,
      default: () => {
        return {
          name: 'A. 小美容',
          alias: 'store-small-dog-a',
          basePrice: 700,
          price: 700,
          store: {
            name: '台北店',
          },
          sizeTitle: '小型 (3-5kg)',
          categoryTitle: '狗狗',
          serviceTime: 120,
          times: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:01', '17:02', '17:03'],
        }
      },
    },
    timesInfo: {
      type: Object,
      default: () => {
        return {
          '10:30': {
            canTimeOrder: true,
            scheduleItems: [],
          },
        }
      },
    },
    hasTimes: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    disabledDayList() {
      return getDefaultReservationDisabledDayList({
        storeAlias: this.reservationItem.store.alias,
        type: 'element',
      })
    },
    isIncludDisabledDayList() {
      return this.disabledDayList.includes(getISODay(parseISO(this.submitData.date)).toString())
    },
    billList() {
      return conditionList([
        {
          title: `1${this.$globalIsDingBeauty ? '<i class="fontello fontello-db-lipstick fa-fw ml-2 text-primary"></i>' : '<i class="fontello fontello-paw fa-fw ml-2 text-primary-dark"></i>'}`,
          text: `${
            this.reservationItem.levelDiscount > 0
              ? `<span class="">
                  會員價：NT$ ${this.priceTotal}
                </span>
                <br>
                <span class="font-number text-decoration-line-through fs-2sm text-gray-2">售價：NT$ ${this.basePrice}</span>
                `
              : `${this.priceTotal}`
          }`,
          textClass: 'font-number',
          condition: () => {
            return true
          },
        },
        {
          title: `${
            this.activeMemberApplicablePrepaidItem().prepaid ? this.activeMemberApplicablePrepaidItem().prepaid.title : `${this.currentMerchant?.prepaidSetting?.title || this.$('site.PREPAID_TITLE')}`
          }`,
          text: `- NT$ ${this.basePrice}`,
          textClass: 'font-number',
          class: 'text-danger',
          condition: () => {
            return !!this.$route.query.prepaidId
          },
        },
        {
          type: 'hr',
        },
        {
          title: '總計',
          text: this.$route.query.prepaidId ? '免費(NT$ 0)' : `NT$ ${this.priceTotal}`,
          class: 'align-items-end',
          textClass: this.$globalIsDingBeauty ? 'font-number fw-semi-bold fs-xl text-secondary' : 'text-primary-dark font-number fw-semi-bold fs-xl',
          condition: () => {
            return true
          },
        },
      ])
    },
    isScheduleItemIdCanAssign() {
      if (!this.submitData?.scheduleItemId[0]) {
        return true
      } else return this.timesInfo[this.submitData.time]?.scheduleItems.find((item) => item.id === this.submitData?.scheduleItemId[0]).canOrder
    },
    priceTotal() {
      const firstTimesInfo = Object.keys(this.timesInfo).length > 1 ? Object.keys(this.timesInfo)[0] : ''
      if (this.submitData?.scheduleItemId && this.submitData?.scheduleItemId[0] && firstTimesInfo) {
        const price = this.timesInfo[firstTimesInfo].scheduleItems.find((item) => item.id === this.submitData?.scheduleItemId[0]).price
        return formatCurrency(this.reservationItem.levelDiscount > 0 ? memberLevelPriceDiscount(price, this.reservationItem) : price)
      } else {
        return formatCurrency(this.reservationItem.levelDiscount > 0 ? memberLevelPriceDiscount(this.reservationItem.price, this.reservationItem) : this.reservationItem.price)
      }
    },
    basePrice() {
      const firstTimesInfo = Object.keys(this.timesInfo).length > 1 ? Object.keys(this.timesInfo)[0] : ''
      if (this.submitData?.scheduleItemId && this.submitData?.scheduleItemId[0] && firstTimesInfo) {
        const price = this.timesInfo[firstTimesInfo].scheduleItems.find((item) => item.id === this.submitData?.scheduleItemId[0]).price
        return formatCurrency(price)
      } else {
        return formatCurrency(this.reservationItem.price)
      }
    },
  },
  methods: {
    chooseTime() {
      if (this.isLoggedIn) {
        this.hasTimes ? this.scrollToId('time') : this.scrollToId('date')
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {},
        })
      }
    },
    formatPrice,
    formatDate,
    memberLevelPriceDiscount,
    onSubmit() {
      const loggedInFn = () => {
        const isNotCanSelectStore = () => {
          if (this.isHasReservationInCart) {
            return this.reservationItem.store.alias !== this.currentUnpaidContiner[0].orders.items[0].product.alias
          } else {
            return false
          }
        }
        this.$nextTick(() => {
          if (this.isBlock) {
            this.$globalDialog('DialogBlock', {})
            return
          }
          if (this.isHasReservationInCart && !!this.currentUnpaidContiner[0]?.['parent_id']) {
            this.$alert(`加購訂單尚未結帳完成，無法加入新預約`, {
              title: `提示`,
              showClose: false,
              dangerouslyUseHTMLString: true,
            }).finally(() => {})
            return false
          }
          if (this.isHasReservationInCart && isNotCanSelectStore()) {
            this.$alert(`無法預約不同分店，請重新選擇`, {
              title: `提示`,
              showClose: false,
              dangerouslyUseHTMLString: true,
            }).finally(() => {})
            return false
          }
          this.tryToStoreCart()
            .then(() => {
              const goToReservationCheckout = () => {
                this.$router.push({
                  name: 'add-reservation',
                  params: {
                    reservationAlias: this.reservationItem.alias,
                  },
                })
              }

              goToReservationCheckout()
            })
            .catch((e) => {
              if (e.status === 'STATUS_CODE_UNDEFINED') {
                this.$globalDialog('DialogBlock', {})
              }
            })
        })
      }

      if (this.isLoggedIn) {
        loggedInFn()
      } else {
        this.$globalDialog('DialogLogin', {
          callbackLogin: () => {
            this.$nextTick(() => {
              loggedInFn()
            })
          },
        })
      }
    },
    scrollToId(id) {
      this.$scrollToElement({
        $el: document.getElementById(id),
        offset: 100,
      })
    },
    async tryToStoreCart() {
      await this.$store
        .dispatch('cart/storeCart', {
          prepaidOrderUuid: this.$route.query.prepaidId || undefined,
          inventoryAlias: `${formatDate(this.submitData.date, 'yyyy-MM-dd')} ${this.submitData.time}`,
          params: [
            {
              alias: this.reservationItem.alias,
              qty: 1,
            },
          ],
          petId: this.$route.query.petId || undefined,
          scheduleItemIds: this.submitData.scheduleItemId || undefined,
        })
        .then(() => {
          return true
        })
    },
    activeMemberApplicablePrepaidItem() {
      const memberApplicablePrepaidOptionsItems = memberApplicablePrepaidOptions().filter((item) => {
        return item.value === this.$route.query.prepaidId
      })

      return memberApplicablePrepaidOptionsItems[0] || {}
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.itemInfoBoxJtails {
  padding: 2.25rem 1.875rem;
  background: #fff;
  box-shadow: 2px 8px 36px #1c2c5414;

  @include max-md {
    padding: 0.75rem $container-gap;
    padding-bottom: 0.75rem;
    padding-bottom: calc(0.75rem + constant(safe-area-inset-bottom));
    padding-bottom: calc(0.75rem + env(safe-area-inset-bottom));
    border-radius: 0;
    box-shadow: 0 -1px 4px #1c2c5414;
  }

  :global {
    .itemInfoBoxJtails {
      &__title {
        margin-bottom: 1rem;
        font-size: 1.25rem;
        font-weight: 600;

        @extend %FontSerifWeightJtails;

        @include max-md {
          display: none;
        }
      }

      &__info {
        margin-bottom: 2rem;
        font-size: 0.875rem;
        line-height: 2;
        color: $color-gray-2;

        @include max-md {
          display: none;
        }
      }

      &__prepaid-info {
        width: 100vw;
        padding-bottom: 0.5rem;
        padding-left: 24px;
        margin-right: -24px;
        margin-bottom: 0.8rem;
        margin-left: -24px;
        font-size: 0.75rem;
        border-bottom: $color-gray-4 1px solid;

        @include min-md {
          display: none;
        }
      }

      &__mobile-info {
        @include max-md {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }

        &__inner {
          @include max-md {
            display: flex;
            justify-content: space-between;
          }
        }

        &__left {
          @include min-md {
            display: none;
          }
        }

        &__title {
          display: block;
          margin-bottom: 0.25rem;
          font-family: $font-number;
          font-size: 1.125rem;
          font-weight: 600;
          line-height: 1;
        }

        .baseButton {
          @include max-md {
            width: auto;
            padding: 0.2rem 1.5rem;
            font-size: 0.875rem;
          }
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .itemInfoBoxJtails {
        &__title {
          font-family: unset;
          color: $color-secondary;
          font-weight: 500;
        }
      }
      .fontello-db-lipstick {
        font-size: 1rem;
        position: relative;
        left: -2px;
      }
    }
  }
}
</style>
